import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { TranslatedModal } from "../../../../../../shared/components/modals";
import { PermissionCheck } from "../../../../../../shared/components/auth";
import {
  Actions,
  Targets,
} from "features/../../../shared/constants/permissions";
import { ModalBuilder, Form, ErrorMessage } from "@redriver/cinnamon";
import { getAccountCreditDetails, requestAccountCredit } from "../actions";
import { Button } from "semantic-ui-react";
import DatabaseIconGroup from "../SheetComponents/databaseIconGroup";
import { FormattedNumericInput } from "features/../../../shared/components/forms";

const AccountCreditRequestModal = ({ clientId, disabled }) => {
  const { t } = useTranslation("agreements", {
    keyPrefix: "AccountCredit",
  });
  const [includeUpgrade, setIncludeUpgrade] = useState(false);
  const [additionalComments, setAdditionalComments] = useState("");

  return (
    <PermissionCheck
      action={Actions.UpdateCreditAvailable}
      target={Targets.Schedules}
    >
      <ModalBuilder
        withForm
        loadAction={getAccountCreditDetails}
        loadParams={clientId}
        submitAction={requestAccountCredit}
        submitParams={clientId}
        renderTrigger={(showModal) => (
          <Button
            primary
            onClick={showModal}
            className="new-account-credit"
            disabled={disabled}
          >
            <div className="account-credit-button">
              <DatabaseIconGroup />
              <span className="account-credit-text">{t("renderTrigger")}</span>
            </div>
          </Button>
        )}
        renderModal={(modalProps, formProps, { error }) => (
          <TranslatedModal
            {...modalProps}
            header={t("Header")}
            submitLabel={t("Submit_Label")}
            className="credit-clearance"
          >
            <Form {...formProps}>
              <Form.Group className="grid two-col top">
                <Form.Input
                  field="name"
                  label={t("Form.CustomerName_Label")}
                  inline
                  readOnly
                />
                <Form.Input
                  field="companyRegNo"
                  label={t("Form.CoRegNo_Label")}
                  inline
                  readOnly
                />
              </Form.Group>

              <Form.Group className="address">
                <Form.Input
                  field="address"
                  label={t("Form.Address_Label")}
                  fluid
                  inline
                  readOnly
                />
              </Form.Group>

              <Form.Group className="grid two-col contacts">
                <Form.Input
                  field="contactName"
                  label={t("Form.Contact_Label")}
                  inline
                  readOnly
                />
                <Form.Input
                  field="email"
                  label={t("Form.Email_Label")}
                  inline
                  readOnly
                />
                <Form.Input
                  field="phone"
                  label={t("Form.Phone_Label")}
                  inline
                  readOnly
                />
                <Form.Input
                  field="website"
                  label={t("Form.Website_Label")}
                  inline
                  readOnly
                />
              </Form.Group>

              <hr />

              <Form.Group className="grid schedule">
                <FormattedNumericInput
                  label={t("Form.AccountCredit_Label")}
                  field="accountCredit"
                  subLabel={t("Form.AccountCredit_SubLabel")}
                  subLabelPosition="left"
                  placeholder={t("Header")}
                  inline
                  decimalPlaces={2}
                />
                <Form.Checkbox
                  field="includeUpgrade"
                  label={t("Form.IncludeUpgrade_Label")}
                />
                <Form.TextArea
                  field="additionalComments"
                  label={t("Form.AdditionalComments_Label")}
                  width="100%"
                />
              </Form.Group>
            </Form>
            <ErrorMessage error={error} />
          </TranslatedModal>
        )}
      />
    </PermissionCheck>
  );
};

export default AccountCreditRequestModal;
